import { _ as __makeTemplateObject } from './chunk-525a49bc.js';
import React from 'react';
import styled from 'styled-components';
import { L as LoadingOverlay } from './chunk-53391a7d.js';

var LoadingBlock = function (_a) {
    var height = _a.height, backgroundColor = _a.backgroundColor;
    return (React.createElement(SpinnerContainer, { height: height },
        React.createElement(LoadingOverlay, { isLoading: true, backgroundColor: backgroundColor })));
};
LoadingBlock.defaultProps = {
    height: '250px',
    backgroundColor: 'none',
};
var SpinnerContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  height: ", ";\n"], ["\n  position: relative;\n  height: ", ";\n"])), function (_a) {
    var height = _a.height;
    return height;
});
var templateObject_1;

export { LoadingBlock as L };
